import ReceivingReportHeaderFilter from './ReceivingReportHeaderFilter';
import ReceivingReportTable from './ReceivingReportTable';

const ReceivingReportPage = () => {
  return (
    <>
      <div className={'page-wrapper'}>
        <ReceivingReportHeaderFilter />
        <ReceivingReportTable />
      </div>
    </>
  );
};

export default ReceivingReportPage;
